const text = {
  en: {
    // Title
    title: "Document Requests Management",
    subtitle: "Manage employee document requests efficiently",

    // Tabs
    pending: "Pending",
    completed: "Completed",
    lastMonth: "Last Month",

    // Empty States
    noPendingRequests: "No Pending Requests",
    noPendingDesc: "All document requests have been processed",
    noCompletedRequests: "No Completed Requests",
    noCompletedDesc: "No documents generated in the last month",

    // Request Details
    employeeName: "Employee Name",
    type: "Type",
    recipient: "Recipient",
    reason: "Reason",
    requestDate: "Request Date",
    requestedDate: "Requested",
    completedDate: "Completed",
    rejectedDate: "Rejected",
    comments: "Comments",
    notAvailable: "N/A",
    unknownEmployee: "Unknown Employee",

    // Buttons
    processRequest: "Process Request",
    download: "Download",
    preview: "Preview",
    approve: "Approve",
    reject: "Reject",
    approveGenerate: "Approve & Generate",
    approveUpload: "Approve Upload",
    cancel: "Cancel",

    // Modal
    processDocumentRequest: "Process Document Request",
    addComments: "Add comments (optional)",
    addCommentsPlaceholder: "Enter your comments here...",

    // Messages
    documentGenerated: "Document generated and sent to employee!",
    processingFailed: "Failed to process request",
    downloadFailed: "Failed to download document",
    requestRejected: "Request rejected successfully",

    // Loading
    loading: "Loading...",
    processing: "Processing...",

    // Duplicate modal
    duplicateTitle: "Existing Document Conflict",
    duplicateSubtitle:
      "This employee already has a document of this type. Approving will replace it.",
    duplicateCurrent: "Current",
    duplicateNew: "New (Pending)",
    duplicateUploaded: "Uploaded:",
    duplicateRequested: "Requested:",
    duplicateApproveReplace: "Approve & Replace",
    duplicateProcessing: "Processing...",
  },
  ar: {
    // Title
    title: "إدارة طلبات المستندات",
    subtitle: "إدارة طلبات مستندات الموظفين بكفاءة",

    // Tabs
    pending: "قيد الانتظار",
    completed: "مكتملة",
    lastMonth: "الشهر الماضي",

    // Empty States
    noPendingRequests: "لا توجد طلبات معلقة",
    noPendingDesc: "تم معالجة جميع طلبات المستندات",
    noCompletedRequests: "لا توجد طلبات مكتملة",
    noCompletedDesc: "لم يتم إنشاء مستندات خلال الشهر الماضي",

    // Request Details
    employeeName: "اسم الموظف",
    type: "النوع",
    recipient: "المستلم",
    reason: "السبب",
    requestDate: "تاريخ الطلب",
    requestedDate: "تاريخ الطلب",
    completedDate: "تاريخ الإتمام",
    rejectedDate: "تاريخ الرفض",
    comments: "التعليقات",
    notAvailable: "غير متوفر",
    unknownEmployee: "موظف غير معروف",

    // Buttons
    processRequest: "معالجة الطلب",
    download: "تنزيل",
    preview: "معاينة",
    approve: "موافقة",
    reject: "رفض",
    approveGenerate: "موافقة وإنشاء",
    approveUpload: "اعتماد المستند المرفوع",
    cancel: "إلغاء",

    // Modal
    processDocumentRequest: "معالجة طلب المستند",
    addComments: "إضافة تعليقات (اختياري)",
    addCommentsPlaceholder: "أدخل تعليقاتك هنا...",

    // Messages
    documentGenerated: "تم إنشاء المستند وإرساله للموظف!",
    processingFailed: "فشلت معالجة الطلب",
    downloadFailed: "فشل تنزيل المستند",
    requestRejected: "تم رفض الطلب بنجاح",

    // Loading
    loading: "جاري التحميل...",
    processing: "جاري المعالجة...",

    // Duplicate modal
    duplicateTitle: "مستند موجود بالفعل",
    duplicateSubtitle:
      "يمتلك هذا الموظف بالفعل مستنداً من هذا النوع. هل تريد الموافقة على استبداله؟",
    duplicateCurrent: "الحالي",
    duplicateNew: "جديد (معلق)",
    duplicateUploaded: "تم الرفع:",
    duplicateRequested: "طُلب في:",
    duplicateApproveReplace: "موافقة واستبدال",
    duplicateProcessing: "جارٍ المعالجة...",
  },
};

export default text;